var _defs, _rect, _rect2, _rect3, _path, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgSizeLarge = function SvgImgSizeLarge(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 221 148",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "img-size-large_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m109.918 67.966-29.69 47.009c-1.226 1.941.17 4.472 2.465 4.472h59.38c2.296 0 3.69-2.531 2.465-4.472l-29.691-47.009c-1.143-1.811-3.785-1.811-4.929 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M141.995 82.453 121.1 114.956c-1.247 1.94.146 4.491 2.452 4.491h41.79c2.306 0 3.699-2.551 2.452-4.491l-20.895-32.503c-1.148-1.785-3.757-1.785-4.904 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.936,
    cy: 61.149,
    r: 11.66,
    fill: "#000"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 147,
    x: 0.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 7.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 57,
    y: 14,
    fill: "currentColor",
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 10,
    x: 70,
    y: 14,
    fill: "currentColor",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 8a8 8 0 0 1 8-8h37a1 1 0 0 1 1 1v146a1 1 0 0 1-1 1H8a8 8 0 0 1-8-8z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 102.021,
    x: 57,
    y: 32,
    fill: "currentColor",
    mask: "url(#img-size-large_svg__a)",
    rx: 5.83
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgSizeLarge);
export default ForwardRef;